import React from 'react';
import { Button, Card, Typography, message } from 'antd';
import logo from '../../assets/icons/futurxLogo.svg';
import { useNavigate, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useLogout } from '../../hooks/useLogout';
import upgradeIcon from "../../assets/icons/premiumCrown.svg";
import { useAppSelector } from '../../hooks/useTypedSelector';
import { setShowModalRequest } from '../../redux/mobileVerificationSlice';
import { useDispatch } from 'react-redux';

const { Paragraph } = Typography;

interface ErrorPageProps {
  messageText?: string;
  showLogout?: boolean;
  showGoBack?: boolean;
  showLogin?: boolean;
  showUpgrade?: boolean;
  showMobileVerification?: boolean;
  is429Error?: boolean;
  isSessionExpired?: boolean;
}

const ErrorPage: React.FC<ErrorPageProps> = ({ messageText, showLogout = false, showGoBack = false, showLogin = false, showUpgrade = false, showMobileVerification = false, is429Error = false, isSessionExpired = false }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [sessionMsg, setSessionMsg] = useState<string | null>(null);
  const mobileUnverifiedUser = useAppSelector((state) => state.mobileVerificationData);
  const dispatch = useDispatch();
  const isCourse = location.pathname.includes('course');

  useEffect(() => {
    // Read and clear the error message from sessionStorage
    const msg = sessionStorage.getItem('mismatched_login_error');
    if (msg) {
      setSessionMsg(msg);
      sessionStorage.removeItem('mismatched_login_error');
    }
  }, []);
  const { logout } = useLogout();

  const handleLogout = async () => {
    try {
      const returnTo = isSessionExpired ? '/login?auto=true' : '/login';
      await logout({ returnTo });
    } catch (error) {
      console.error('Logout failed:', error);
      message.error('Failed to logout. Please try again.');
    }
  };

  const handleLogin = async () => {
    try {
      await logout({ returnTo: '/login?auto=true' });
    } catch (error) {
      console.error('Login redirect failed:', error);
      message.error('Failed to redirect. Please try again.');
    }
  };

  return (
    <div
      style={{
        backgroundColor: '#f0f4f9',
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '16px',
      }}
    >
      <Card
        style={{
          width: '100%',
          maxWidth: 500,
          textAlign: 'center',
          borderRadius: 16,
          padding: '8px 32px',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.05)',
        }}
        bordered={false}
      >
        <img
          src={logo}
          alt="FuturX Logo"
          style={{
            height: 120,
            marginBottom: 40,
            objectFit: 'contain',
          }}
        />

        <Paragraph style={{ fontSize: 16, color: '#4A4A4A', marginBottom: 32 }}>
          {sessionMsg || location.state?.messageText || messageText}
        </Paragraph>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 16, alignItems: 'center' }}>
          {showUpgrade && (
            <Button
              size="large"
              onClick={() => { navigate("/upgrade") }}
              style={{
                borderRadius: 6,
                padding: '0 32px',
                backgroundColor: "#f3f5f7ff",
                border: "1px solid #0056D2",
                color: "black",
                width: '100%',
                maxWidth: 240,
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
              }}
            >
              <img src={upgradeIcon} alt="Upgrade" style={{ width: 24, height: 24, marginTop: "-3px" }} />
              Upgrade
            </Button>
          )}

          {mobileUnverifiedUser && is429Error && (
            <Button
              type="primary"
              size="large"
              onClick={() => {
                isCourse ? navigate("/course") : navigate("/college")
                sessionStorage.setItem("mobile_verify_redirect", window.location.pathname);
                dispatch(setShowModalRequest(true));
              }
              }
              style={{ borderRadius: 6, padding: '0 32px', width: '100%', maxWidth: 240 }}
            >
              Verify Mobile Number
            </Button>
          )}

          {showGoBack && (
            <Button
              type={mobileUnverifiedUser ? "default" : "primary"}
              size="large"
              onClick={() => navigate("/search")}
              style={{ borderRadius: 6, padding: '0 32px', width: '100%', maxWidth: 240 }}
            >
              Go to Search Page
            </Button>
          )}

          {showLogout && (
            <Button
              type="primary"
              size="large"
              onClick={handleLogout}
              style={{
                borderRadius: 6,
                padding: '0 32px',
                backgroundColor: "white",
                border: "1px solid #E0E0E0",
                color: "black",
                width: '100%',
                maxWidth: 240
              }}
            >
              Logout
            </Button>
          )}

          {showLogin && (
            <Button
              type="primary"
              size="large"
              onClick={handleLogin}
              style={{
                borderRadius: 6,
                padding: '0 32px',
                backgroundColor: "#0056D2",
                border: "1px solid #0056D2",
                color: "white",
                width: '100%',
                maxWidth: 240
              }}
            >
              Login
            </Button>
          )}
        </div>

      </Card>
    </div>
  );
};

export default ErrorPage;
